module.exports = __webpack_public_path__ + "static/media/voz_icon.eb1d749c.svg";